// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__9ca7n","rotation":"SmallLoader_rotation__TMRtc"};